<template>
  <svg
    class="icon fill-current"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C17.5229 2 22 6.47714 22 12C22 17.5229 17.5229 22 12 22C6.47714 22 2 17.5229 2 12C2 6.47714 6.47714 2 12 2ZM12.001 16.6562C11.078 16.6565 10.3301 17.4051 10.3301 18.3281C10.3301 19.2512 11.078 19.9997 12.001 20C12.9242 20 13.6729 19.2513 13.6729 18.3281C13.6728 17.4049 12.9242 16.6562 12.001 16.6562ZM11.3154 4C10.9082 4.00004 10.5829 4.33924 10.5996 4.74609L11.0176 14.7764C11.0338 15.1599 11.3495 15.4629 11.7334 15.4629H12.2695C12.6535 15.4628 12.9692 15.1599 12.9854 14.7764L13.4033 4.74609C13.4201 4.33927 13.0946 4.00008 12.6875 4H11.3154Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'WarningFilledIcon'
}
</script>
